// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  font-family: 'Cormorant Garamond', serif;
  font-size: 15px;
  font-weight: 475;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: none;
  white-space: nowrap;
}

.vertically-centered {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.link {
  text-decoration: none;
  color: black;
}

span.hidden {
  visibility: hidden;
}

#button {
  position: fixed;
  right: 5px;
  border: none;
  font-size: 20px;
  font-weight: 575;
  padding: 20px;
  color: lightgray;
  letter-spacing: 3px;
  transition: 1000ms;
  transform: rotate(-45deg) scale(1, 1.5);
  z-index: 2;
}

#button:hover {
  color: gray;
  letter-spacing: 6px;
}

#button:active {
  border: none;
  outline: none;
}

/* Fullscreen Button Visibility: */
.display {
  opacity: 1;
}
.hide {
  opacity: 0;
}

/* Cursor Visibility: */
.default {
  cursor: default;
}
.none {
  cursor: none;
}

*:-webkit-full-screen {
  background: #fff;
}

*:fullscreen {
  background: #fff;
}

@media (max-width: 800px) {
  p,
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    white-space: normal;
    line-height: 10.5px;
  }
  #button {
    opacity: 0;
  }
  .You-must-have-regard > p,
  .I-am-the-inheritor > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 200px;
    line-height: 3.5px;
  }
}
.link::before {
  content: "\\00A0";
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;AAClB","sourcesContent":["body,\nhtml {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: 'Cormorant Garamond', serif;\n  font-size: 15px;\n  font-weight: 475;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  cursor: none;\n  white-space: nowrap;\n}\n\n.vertically-centered {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.link {\n  text-decoration: none;\n  color: black;\n}\n\nspan.hidden {\n  visibility: hidden;\n}\n\n#button {\n  position: fixed;\n  right: 5px;\n  border: none;\n  font-size: 20px;\n  font-weight: 575;\n  padding: 20px;\n  color: lightgray;\n  letter-spacing: 3px;\n  transition: 1000ms;\n  transform: rotate(-45deg) scale(1, 1.5);\n  z-index: 2;\n}\n\n#button:hover {\n  color: gray;\n  letter-spacing: 6px;\n}\n\n#button:active {\n  border: none;\n  outline: none;\n}\n\n/* Fullscreen Button Visibility: */\n.display {\n  opacity: 1;\n}\n.hide {\n  opacity: 0;\n}\n\n/* Cursor Visibility: */\n.default {\n  cursor: default;\n}\n.none {\n  cursor: none;\n}\n\n*:fullscreen {\n  background: #fff;\n}\n\n@media (max-width: 800px) {\n  p,\n  span {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    white-space: normal;\n    line-height: 10.5px;\n  }\n  #button {\n    opacity: 0;\n  }\n  .You-must-have-regard > p,\n  .I-am-the-inheritor > p {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    max-width: 200px;\n    line-height: 3.5px;\n  }\n}\n.link::before {\n  content: \"\\00A0\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
